import { useContext, useEffect, useState } from 'react'
import { trpc } from '../../modules/trpc'
import { ModalContext } from '../ModalContext'
import { ObjectContext } from '../objectContext/ObjectContext'
import { useConsumptionReports } from './useConsumptionReports'

interface Report {
	id: number
	heatingType: string
	type: string
	temperature: number
	personCount: number
	objectId: number
	from: string
	to: string
	totalConsumption: number
	totalCO2: number
	totalBill: number
	heatingConsumption: number
	heatingCO2: number
	applianceConsumption: number
	applianceCO2: number
}

export const useAverages = () => {
	const { activeReportId } = useContext(ModalContext)
	const object = useContext(ObjectContext)
	const reports = useConsumptionReports(object.id)

	const [activeReport, setActiveReport] = useState<Report | null | undefined>(null)

	useEffect(() => {
		if (!reports.data) return

		setActiveReport(reports.data.find(report => report.id === activeReportId))
	}, [reports.data, activeReportId])

	const { data, isLoading } = trpc.objects.getAverages.useQuery(
		{
			from: activeReport?.from || '1.1.2021', // Default to '1.1.2021
			to: activeReport?.to || '1.1.2021', // Default to '1.1.2021
			personCount: activeReport?.personCount || 1,
		},
		{
			enabled: !!activeReport,
		}
	)

	return { data, isLoading }
}
